import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationAR from "./locales/ar/translation.json"
import translationENG from "./locales/eng/translation.json"
import translationGr from "./locales/gr/translation.json"
import translationMal from "./locales/malayalam/translation.json"
import translationChi from "./locales/SimplifiedChinese/translation.json"
import translationTur from "./locales/Turkish/translation.json"
import translationUrdu from "./locales/urdu/translation.json"

// the translations
const resources = {
  en: {
    translation: translationENG,
  },
  ar: {
    translation: translationAR,
  },
  gr: {
    translation: translationGr,
  },
  mal: {
    translation: translationMal,
  },
  chi: {
    translation: translationChi,
  },
  tur: {
    translation: translationTur,
  },
  urdu: {
    translation: translationUrdu,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en")
}
i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
